<!-- An icon to start/stop audio spot preview -->

<template>
  <div
    v-if="message"
    class="poster-wrapper"
    :class="{
      small: small,
      medium: medium,
      full: full,
    }"
    @click="togglePreview()"
  >
    <v-icon
      v-if="!previewing"
      key="notPreviewing"
      class="tickerpreview-icon grey--text"
    >
      textsms
    </v-icon>
    <div
      v-if="previewing"
      key="previewing"
      class="tickerpreview-icon grey--text"
    >
      <ticker-preview
        :message="message"
        style="position: relative; z-index: 2"
      />
    </div>
  </div>
</template>

<script>
import TickerPreview from '@/components/TickerPreview';

export default {
  components: {
    TickerPreview,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    /* Whether starting this stops all others using a global signal. */
    thereCanOnlyBeOne: {
      type: Boolean,
      default: true,
    },
    /** Default preview is tiny. We can increase it. */
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      previewing: false,
    };
  },
  mounted() {
    this.$bus.$on('stop-mini-preview', () => {
      this.stopPreview();
    });
  },
  methods: {
    startPreview() {
      if (this.thereCanOnlyBeOne) {
        this.$bus.$emit('stop-mini-preview');
      }
      this.previewing = true;
      this.$emit('started');
    },
    stopPreview() {
      this.previewing = false;
      this.$emit('stopped');
    },
    togglePreview() {
      this.previewing ? this.stopPreview() : this.startPreview();
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}

.poster-wrapper {
  width: 96px;
  height: 54px;
  display: flex;
  justify-items: center;
}
.poster-wrapper.small {
  width: calc(96px * 2);
  height: calc(54px * 2);
}
.poster-wrapper.medium {
  width: calc(96px * 3);
  height: calc(54px * 3);
}
.poster-wrapper.full {
  width: 100%;
  height: auto;
}

i.tickerpreview-icon {
  width: 100%;
  height: 100%;
  font-size: 4.5em !important;
}
.poster-wrapper.full i.tickerpreview-icon {
  font-size: 16em !important;
}
.poster-wrapper.medium i.tickerpreview-icon {
  font-size: 11em !important;
}
.poster-wrapper.small i.tickerpreview-icon {
  font-size: 7em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniPreviewTicker.vue